// returns whole number to be used in progress loading indicator

export const getRoundedNumber = (queryValue: number) => {
  const percent = !isNaN(queryValue) ? queryValue : 0
  return Math.round(percent)
}
